import { Link, useParams, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LocaleParams } from "../../types";
import HomeMiddleBanners from "./components/HomeMiddleBanners";
import HomeLaunchingsBanners from "./components/HomeLaunchingsBanners";
import ClubText from "./components/ClubText";
import MiddleBanners from "./components/MiddleBanners";
import Categories from "./components/Categories";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { t } from "../../helpers";
import { PHOTOS_URL } from "../../constants";
import { Product, Button, RatingStars } from "@cocunat/ui-components";
import { MainContext } from "../../context/main";
import HeroDesktop from "./components/HeroDesktop";

function Home() {
  const { lang, country } = useParams<LocaleParams>();
  let navigate = useNavigate();
  const { products, productsClub, region } = useContext(MainContext);

  const QUIZ_URL = `/${lang}-${country}/quizz/1/`;

  const goToQuiz = () => {
    navigate(QUIZ_URL);
  };

  return (
    <>
      <Header />
      {region && region.extra && region.extra.club_info && (
        <section id="home">
          <section className="container">
            <Categories lang={lang} country={country} />
          </section>
          <HeroDesktop region={region} lang={lang} country={country} />
          <MiddleBanners lang={lang} country={country} />

          <section className="productCarousel container">
            <h1
              className="align-left"
              style={{ textAlign: "left", marginBottom: 0 }}
            >
              <img
                src={`${PHOTOS_URL}lightening-icon.png`}
                alt="bestSellers"
                style={{ marginRight: 5 }}
              />
              {t("home.bestSellers")}
            </h1>
            <p
              style={{
                textDecoration: "underline",
                marginLeft: 30,
                marginTop: 0,
              }}
            >
              <Link to={`${QUIZ_URL}`}>{t("home.topRated")}</Link>
              <Link to={`${QUIZ_URL}`} style={{ marginLeft: 20 }}>
                {t("home.topAwarded")}
              </Link>
            </p>
            <div className="product-list-mobile">
              <div className="content">
                {productsClub &&
                  productsClub.map((product: any) => (
                    <div
                      className="col-md-3 col-sm-3 col-xs-3"
                      key={product.id}
                    >
                      <Product
                        onNavigate={(e: any) => {
                          e.preventDefault();
                          goToQuiz();
                        }}
                        showClubPrice={true}
                        textPriceClub="PRECIO CLUB"
                        textPrice="PRECIO"
                        key={product.id}
                        data={product}
                        to={
                          "https://cocunat.com/product/" +
                          product.translation.slug
                        }
                      />
                    </div>
                  ))}
              </div>
            </div>

            <div className="product-list-desktop container">
              {productsClub &&
                productsClub.map((product: any) => (
                  <div className="col-md-3 col-sm-6 col-xs-6" key={product.id}>
                    <Product
                      onNavigate={(e: any) => {
                        e.preventDefault();
                        goToQuiz();
                      }}
                      showClubPrice={true}
                      textPriceClub="PRECIO CLUB"
                      textPrice="PRECIO"
                      key={product.id}
                      data={product}
                      to={
                        "https://cocunat.com/product/" +
                        product.translation.slug
                      }
                    />
                  </div>
                ))}
            </div>
            <Link to={`${QUIZ_URL}`}>
              <Button style={{ maxWidth: "200px", margin: "auto" }}>
                {t("allProducts")}
              </Button>
            </Link>
          </section>
          <section
            className="need"
            style={{
              backgroundColor: "#FDE9E6",
              textAlign: "center",
              padding: "25px 15px",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img src={`${PHOTOS_URL}need-icon.png`} alt="club" />
              <h1 style={{ textAlign: "center", margin: 5 }}>
                {t("home.needTitle")}
              </h1>
              <p style={{ textAlign: "center", margin: 5 }}>
                {t("home.needText")}
              </p>
              <Link to={`${QUIZ_URL}`}>
                <Button
                  style={{
                    maxWidth: "200px",
                    background: "none",
                    border: "1px solid black",
                  }}
                >
                  {t("doTest")}
                </Button>
              </Link>

              <small>{t("totallyFree")}</small>
            </div>
          </section>
          <section
            className="lastLaunchings "
            style={{ backgroundImage: `url(${PHOTOS_URL}launhingsBg.png)` }}
          >
            <h1 className="align-left">{t("home.lastLaunchingsTitle")}</h1>
            <Link to={`${QUIZ_URL}`}>
              <HomeLaunchingsBanners
                title={t("home.launchingBanner1Title")}
                buttonText={t("discover")}
                img="homeBottomBanner-1.png"
                link={`${QUIZ_URL}`}
                textPosition="right"
              />
              <HomeLaunchingsBanners
                title={t("home.launchingBanner2Title")}
                buttonText={t("discover")}
                img="homeBottomBanner-2.png"
                link={`${QUIZ_URL}`}
                textPosition="left"
              />
              <HomeLaunchingsBanners
                title={t("home.launchingBanner3Title")}
                buttonText={t("discover")}
                img="homeBottomBanner-3.png"
                link={`${QUIZ_URL}`}
                textPosition="right"
              />
            </Link>
          </section>
          <section className="revies container" style={{ textAlign: "center" }}>
            <Link to={`${QUIZ_URL}`}>
              <div style={{ textAlign: "center" }}>
                <img src={`${PHOTOS_URL}customer-love-icon.png`} alt="club" />
              </div>
              <h1 style={{ textAlign: "center", margin: "10px 10px 20px 0px" }}>
                {t("home.reviewsTitle")}
              </h1>
              <div className="col-xs-6 col-md-12 col-sm-12">
                <img src={`${PHOTOS_URL}gloriRoviReview.png`} alt="Glorirovi" />
              </div>
              <div className="col-xs-6 col-md-12 col-sm-12">
                <p style={{ maxWidth: "300px", margin: "auto" }}>
                  {t("home.reviews_1")}
                </p>
              </div>
              <div className="col-xs-12" style={{ textAlign: "center" }}>
                <p
                  style={{ fontSize: "14px", marginBottom: 0 }}
                  className="font-brown-regular"
                >
                  {t("home.excellent")}
                </p>
                <p style={{ margin: "0px" }}>
                  <RatingStars rating={5} />
                </p>
                <a
                  style={{ margin: "0px", textDecoration: "underline" }}
                  href={`${QUIZ_URL}`}
                  className="font-brown-regular"
                >
                  {t("home.seeReviews")}
                </a>
              </div>
            </Link>
          </section>
          <section className="club" style={{ backgroundColor: "#FDE9E6" }}>
            <div className="container">
              <div style={{ textAlign: "center" }}>
                <img src={`${PHOTOS_URL}diamond-icon.png`} alt="club" />
              </div>
              <h1 style={{ textAlign: "center", margin: 5 }}>
                {t("club.cocunatClub")}
              </h1>
              <p style={{ textAlign: "center", margin: 5 }}>
                {t("club.clubSubtitle")}
              </p>
              <ClubText text={t("club.club_1")} img="club-icon-1.png" />
              <ClubText
                text={t("club.club_2", {
                  to: `${QUIZ_URL}`,
                  price: region.extra.club_price,
                })}
                img="club-icon-2.png"
              />
              <ClubText
                text={t("club.club_3", { to: `${QUIZ_URL}` })}
                img="club-icon-3.png"
              />
              <ClubText text={t("club.club_4")} img="club-icon-4.png" />
              <ClubText text={t("club.club_5")} img="club-icon-5.png" />
              <ClubText text={t("club.club_6")} img="club-icon-6.png" />
              <ClubText text={t("club.club_7")} img="club-icon-7.png" />
              <Link to={`${QUIZ_URL}`}>
                <Button style={{ maxWidth: "200px", margin: "auto" }}>
                  {t("club.discover")}
                </Button>
              </Link>
            </div>
          </section>
        </section>
      )}

      <Footer />
    </>
  );
}

export default Home;
